import { getProfile, updateProfile } from './apis';
import {
  fetchEncryptionKey,
  prepareEncryptedPayload,
  appendIdentityParams,
} from '@/utils/encryptionKey';

const PROFILE_ENCRYPT_FIELDS = ['phone', 'idCardNo'];

/**
 * 获取个人资料（附带 identity，合规专用）
 * 不影响原有 getProfile 接口
 */
export async function getProfileEncrypted(callOptions = {}) {
  try {
    await fetchEncryptionKey();
  } catch (error) {
    // 密钥获取失败时降级，走原接口逻辑
  }

  const params = appendIdentityParams(callOptions.params || {});
  return getProfile({
    ...callOptions,
    params,
  });
}

/**
 * 更新个人资料（加密手机号、身份证号，合规专用）
 * 不影响原有 updateProfile 接口
 */
export async function updateProfileEncrypted(callOptions = {}) {
  const data = await prepareEncryptedPayload(
    callOptions.data || {},
    PROFILE_ENCRYPT_FIELDS
  );
  return updateProfile({
    ...callOptions,
    data,
  });
}
